export const locale = {
  lang: 'zh1',
  data: {
    'PERFIL_USUARIO': {
      'TITULO': '我的簡歷',
      'ENLACES': {
        'configuracion': '帳號設定',
        'notificaciones': '用戶通知',
        'mensajes': '收到的消息'
      },
      'PAGINAS': {
        'configuracion': {
          'TITULO': '帳號設定',
          'OPCIONES': {
            'CAMBIARMAIL': {
              'TITULO': '更改電子郵件',
              'SUBTITULO': '您可以更改帳戶的電子郵件地址',
              'INPUTS': {
                'MAIL': '新的電子郵件地址',
                'TOKEN': '驗證碼',
                'PASS': '新密碼',
                'CONFIRMPASS': '確認密碼'
              },
              'BOTONES': {
                'CAMBIAMAIL': '更改電子郵件',
                'VERTOKEN': '校驗碼',
                'FINALMAIL': '更改電子郵件地址',
              }
            },
            'CAMBIARPASS': {
              'TITULO': '更改密碼',
              'SUBTITULO': '您可以更改您的帳戶密碼',
              'BOTONES': {
                'FINALPASS': '更改密碼'
              }
            },
            'AUTENTICACION': {
              'TITULO': '兩步驗證',
              'SUBTITULO': '您可以通過激活兩步驗證來提高帳戶的安全性',
              'BOTONES': {
                'ACTIVAR': '啟用',
                'DESACTIVAR': '停用'
              }
            }
          }
        }
      },
      'MODALES': {
        'CAMBIARMAIL_PASO1_OK': '一條帶有驗證碼的消息已發送到指定的電子郵件，請輸入收到的驗證碼以繼續該過程',
        'CAMBIARMAIL_PASO1_NOTOK': '無法繼續，輸入的郵箱已在系統中註冊',
        'CAMBIARMAIL_PASO1_SAME': '無法繼續，輸入的電子郵件與當前帳戶相同',
        'CAMBIARMAIL_PASO2_OK': '驗證碼正確，要繼續，您需要在下方輸入新密碼',
        'CAMBIARMAIL_PASO2_NOTOK': '驗證碼不正確，請檢查您輸入的是否正確，然後再次檢查',
        'CAMBIARMAIL_PASO3_NOTOK': '無法繼續，密碼不匹配，請重新正確輸入',
        'CAMBIARMAIL_PASO3_OK': '帳戶數據已正確更新，為完成會話將關閉的過程，使用新的訪問數據重新進入平台',
        'CAMBIAPASS_OK': '賬號密碼更新成功',
        'CAMBIAPASS_NOTOK': '無法繼續，密碼不匹配，請重新正確輸入',
        'AUTHOK': '認證狀態更新成功'
      }
    },
    'PROFILE': {
      'MENU_TITLE':'關      ',
      'MYPROFILLE':'我的簡歷',
      'TITLE':'更改密碼',
       'BTNBACK':'返回',
       'MENUTITLE':'菜單',
       'MENU':{
         'OPC1':'我的資料'
       },
       'NAME':'名稱',
       'EMAIL':'郵件',
       'CODE':'驗證碼',
       'NEWPASS':'新密碼',
       'REPASS':'確認密碼',
       'CHANGE':'更改密碼',
       'SENDCODE':'發送驗證碼',
       'CHECKCODE':'驗證碼',
       'ERROR':{
        'ERROR01':'必填項目',
        'ERROR02':'錯誤，發生了一些事',
        'ERROR03':'代碼不匹配',
        'ERROR04':'密碼不匹配',
        'ERROR05':'至少3個字符',
        'ERROR06':'該電子郵件已經存在，請嘗試使用另一封電子郵件',
        'ERROR07':'公司名稱不符'
      },
      'SUCCESS':{
        'OK':'Ok',
       'MESESAGE1':'數據正確更新',
       'MESESAGE2':'代碼已發送...請檢查您的電子郵件',
       'MESESAGE3':'正確的代碼'
      }

    },
  }
};
